let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dOuOH")).then(() => parcelRequire('9npFn'));